import React, { useEffect, useState } from 'react';
import iconUser from '../../../img/navbar/user.svg';
import carro from '../../../img/navbar/icon_carro.svg';
import buscar from '../../../img/navbar/icon_search.svg';
import buscarBlanco from '../../../img/navbar/icon_buscar_blanco.svg'
import logoHyuidaiD from '../../../img/navbar/azul_logo_hyundai.svg';
import iconMenuM from '../../../img/navbar/icon_menu_mobile.svg';
import iconMenuMBlanco from '../../../img/navbar/icon_menu_mobile_blanco.svg';
import ProductosCarrito from '../productosCarrito/productosCarrito';
import logoHyuidaiM from '../../../img/navbar/mobile_azul_logo_hyundai.svg';
import logoHyuidaiMBlanco from '../../../img/navbar/mobile_blanco_logo_hyundai.svg';

import { Redirect, useParams } from "react-router";

import { Link, useHistory } from 'react-router-dom';
import { Menu, Dropdown, Button, Drawer, Badge, Input } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';
import '../../../css/textsPredefined.css';
import './navbar.css'
import ScrollButton from '../scrollButton/scrollButton';
import SearchMenu from './searchMenu';
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../../redux/actions/loginActions';

import clienteAxios from '../../../configAxios/configAxios';
import { errorSwal } from '../../../helper/swalHelpers';
import WhatsAppButton from '../whatsappButton/whatsappButton';

const Navbar = ({ scrollXL, modalVisible, whatsappVisible }) => {
    const logged = useSelector((state) => state.login.autenticado);
    const user = (useSelector((state) => state.login.user));
    const [show, setShow] = useState(false);
    const [showCarrito, setShowCarrito] = useState(false);
    const [tamañoDrawer, setTamaño] = useState("");
    const [cantidadCarrito, setCantidad] = useState(0);
    const [refreshCarrito, setRefresh] = useState(true)
    
    const [showScrollButton, setShowScrollButton ] = useState(true);

    const [redireccionar, setRedireccionar] = useState(undefined);
    const [busqueda, setBusqueda] = useState("");
   
    const handleShow = () => {
        setShow(true);
    };

    const handleHide = () => {
        setShow(false);
    };

    const currentRoute = useHistory().location.pathname.toLowerCase();

    const mostrarCarrito = () => {
        if (currentRoute === "/carrito") return;
        let width = window.innerWidth;
        if (width <= 615) setTamaño("85%");
        else if (width <= 900) setTamaño("60%");
        else if (width <= 1150) setTamaño("50%");
        else if (width <= 1599) setTamaño("40%")
        else if (width <= 1600) setTamaño("30%");
        else if (width >= 1600) setTamaño("25%")
        setShowCarrito(true);
    }

    const onClose = () => {
        setShowCarrito(false);
    };

    // useEffect(() => {
      
    //     const media = window.matchMedia("(max-width: 767px)");


    //     if(media.matches && currentRoute === "/carrito"){
    //         let navbarMobile = document.getElementsByClassName("navbar-hyundai-mobile");
    //         let navbarDesktop = document.getElementsByClassName("navbar-hyundai");
    //         for (let i = 0; i < navbarMobile.length; i++) {
    //             navbarMobile[i].style.display = "none";
    //         }

    //         for (let i = 0; i < navbarDesktop.length; i++) {
    //             navbarDesktop[i].style.display = "block";
    //         }
    //     }


    // }, [])

    useEffect(() => {
        if (refreshCarrito === true) {
            let actualizarCarrito = () => {
                let carrito = JSON.parse(localStorage.getItem('productos')) || [];
                setCantidad(carrito.length)
            }
            actualizarCarrito();
            setRefresh(false);
        }
    }, [refreshCarrito]);

    if (modalVisible === true) {
        let div = document.getElementById('navBar');
        div?.classList.remove('sticky-top');
    }

    if (modalVisible === false) {
        let div = document.getElementById('navBar');
        div?.classList.add('sticky-top');
    }

    let menu = logged === true ? <MenuLogeado /> : <MenuLogin />

    const handleChange = (e) => {
        setBusqueda(e.target.value)
    }

    useEffect(() => {
      
        if(redireccionar){
            setRedireccionar(undefined);
        }

    }, [redireccionar])

    const realizarBusqueda = async () => {
        try {
        
            if(busqueda) {
        
                setRedireccionar({
                    pathname: "/buscar",
                    state: {
                        palabraBuscar: busqueda,
                        reload: false
                    },
                });
                handleHide();
               
            } 

        } catch (error) {
            errorSwal("Ocurrió un error", "Vuelve a intentarlo más tarde", "Volver a intentar");
        }
    }

    const handleBuscar = () => {
        if (busqueda && busqueda.length >= 3) {
            realizarBusqueda();
            return;
        }
        errorSwal("Ocurrió un error", "Debes ingresar al menos 3 caracteres para realizar una búsqueda.", "Volver a intentar");
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleBuscar();
    }

    
    useEffect(() => {
        const media = window.matchMedia("(max-width: 767px)");
        if(media.matches){
            setShowScrollButton(false);
        } else {
            setShowScrollButton(true); 
        }
    }, []);


    if (redireccionar) return <Redirect push={false} to={redireccionar} />;

    return (
        <nav className="sticky-top">
            <Container className={`px-lg-auto navbar-hyundai ${currentRoute.includes('outlet') && 'd-block'}`} fluid>
                <Row className="justify-content-end navbar-busqueda-carrito">
                    <Col xs={12} className="text-right">
                        <Dropdown overlay={menu} className="px-md-2 px-2 mobile-style my-2 my-md-0 dropdown-hyundai" placement="bottomCenter" trigger={["click"]}>
                            {/* eslint-disable-next-line */}
                            <a className="ant-dropdown-link color-white-hy parrafo-hyundai  f-responsive" onClick={e => e.preventDefault()} href="#">
                                <img src={iconUser} alt="usuario" className="img-fluid pr-1" /> {user ? user.Nombre : ''}
                            </a>
                        </Dropdown>
                        <Link to="/buscar" className="px-md-2 px-2 d-none d-md-inline-block">
                            <img className="my-2 my-md-2" alt="buscar-hyundai" src={buscar} />
                        </Link>
                        {/* OUTLET OFF */}
                        <Button type="text" className="h-100" onClick={mostrarCarrito}>
                            <Badge size="small" style={{ backgroundColor: '#03306C' }} count={cantidadCarrito}><img src={carro} className="" alt="carrito-hyundai" /></Badge>
                        </Button>
                        <Drawer
                            title={<h6 className="bold-title-hyundai t-carrito-m mt-4 f-responsive">Resumen de carro de compras<br />
                                {cantidadCarrito === 0 ? '' : cantidadCarrito === 1 ? '(' + cantidadCarrito + ' producto)' : '(' + cantidadCarrito + 'productos'}</h6>}
                            closable={true}
                            onClose={onClose}
                            visible={showCarrito}
                            className="drawer-carrito"
                            width={tamañoDrawer}
                        >
                            <ProductosCarrito actualizarCarrito={showCarrito} refrescar={setRefresh} />
                        </Drawer>

                    </Col>
                </Row>
                <Row className="shadow-navbar-hyundai">
                    <Col className="d-none d-md-block text-md-center text-lg-left my-4" xs={3} sm={3} md={12} lg={3} xl={3}  >
                        <Link to="/"> <img className="ml-2" alt="logo-hyundai" src={logoHyuidaiD} /></Link>
                    </Col>
                    <Col className="d-md-none">
                        <Row>
                            <Col className="my-auto"><Link to="/"><img alt="logo-hyundai" src={logoHyuidaiM} /> </Link></Col>
                            <Col>
                                <Row className="justify-content-end">
                                    <button onClick={handleShow} className="btn bg-transparent">
                                        <img alt="menu-responsive-hyundai" src={iconMenuM} />
                                    </button>
                                </Row>
                            </Col>
                            <Drawer
                                className="drawer-mobile-menu"
                                placement="left"
                                closable={true}
                                onClose={handleHide}
                                visible={show}
                                key="left"
                                zIndex={1030}
                            >
                                <Container fluid >
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={9} xl={9} className={`d-block d-md-none `} >
                                            <Row className=" justify-content-md-center justify-content-lg-end mt-3">
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/vehiculos">
                                                        <p className={` ${currentRoute.includes("vehiculos") && !currentRoute.includes("outlet")  ? "active-link" : ""} link-text py-1 my-2`}>Vehículos</p>
                                                    </Link>
                                                </Col>
                                                {/* OUTLET OFF */}
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/outlet/vehiculos">
                                                        <p className={`${currentRoute.includes("outlet") && "active-link"} link-text py-1 my-2`}>Outlet</p>
                                                    </Link>
                                                </Col>
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/concesionarios">
                                                        <p className={`${currentRoute.includes("concesionario") && "active-link"} link-text py-1 my-2`}>Concesionarios</p>
                                                    </Link>
                                                </Col>
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/servicio-tecnico">
                                                        <p className={` ${currentRoute.includes("serviciot") && "active-link"} link-text py-1 my-2`}>Servicio técnico</p>
                                                    </Link>
                                                </Col>
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/repuestos">
                                                        <p className={` ${currentRoute.includes("repuestos") && !currentRoute.includes("outlet")  ? "active-link" : ""} link-text py-1 my-2`}>Repuestos</p>
                                                    </Link>
                                                </Col>
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/flotas">
                                                        <p className={`${currentRoute.includes("flotas") && "active-link"} link-text py-1 my-2`}>Flotas</p>
                                                    </Link>
                                                </Col>
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/mercado-publico">
                                                        <p className={`${currentRoute.includes("mercado") && "active-link"} link-text py-1 my-2`}>Mercado público</p>
                                                    </Link>
                                                </Col>
                                                <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                    <Link className="text-left" to="/atencion-al-cliente">
                                                        <p className={`${currentRoute.includes("atencion") && "active-link"} link-text py-1 my-2`}>Servicio al cliente</p>
                                                    </Link>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Container>
                            </Drawer>
                        </Row>

                    </Col>
                    <Col xs={12} sm={12} md={12} lg={9} xl={9} className={`my-auto d-none d-md-block `} >
                        <Row className=" justify-content-md-center justify-content-lg-end mt-md-3 mt-lg-0">
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/vehiculos">
                                    <p className={` ${currentRoute.includes("vehiculos") && !currentRoute.includes("outlet")  ? "active-link" : ""} mb-0 link-text mt-3 mt-md-0 px-lg-auto link-text `}>Vehículos</p>
                                </Link>
                            </Col>
                            {/* OUTLET OFF */}
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/outlet/vehiculos">
                                    <p className={`${currentRoute.includes("outlet") && "active-link"}  mb-0 mt-3 mt-md-0 px-lg-auto link-text`}>Outlet</p>
                                </Link>
                            </Col>
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/concesionarios">
                                    <p className={`${currentRoute.includes("concesionario") && "active-link"}  mb-0 mt-3 mt-md-0 px-lg-auto  link-text`}>Concesionarios</p>
                                </Link>
                            </Col>
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/servicio-tecnico">
                                    <p className={` ${currentRoute.includes("servicio-tecnico") && "active-link"} mb-0 mt-3 mt-md-0 px-lg-auto  link-text`}>Servicio técnico</p>
                                </Link>
                            </Col>
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/repuestos">
                                    <p className={` ${currentRoute.includes("repuestos") && !currentRoute.includes("outlet")  ? "active-link" : ""} mb-0 link-text mt-3 mt-md-0 px-lg-auto link-text `}>Repuestos</p>
                                </Link>
                            </Col>
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/flotas">
                                    <p className={`${currentRoute.includes("flotas") && "active-link"} mb-0 mt-3 mt-md-0 px-lg-auto link-text`}>Flotas</p>
                                </Link>
                            </Col>
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto">
                                <Link className="text-center" to="/mercado-publico">
                                    <p className={`${currentRoute === "/mercado-publico" && "active-link"}  mb-0 mt-3 mt-md-0  link-text`}>Mercado público</p>
                                </Link>
                            </Col>
                            <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 padding-menu mx-xl-auto ">
                                <Link className="text-center" to="/atencion-al-cliente">
                                    <p className={`${currentRoute.includes("atencion") && "active-link"} mb-0 mt-3 mb-3 mb-md-0 mt-md-0  link-text`}>Servicio al cliente</p>
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

            {!currentRoute.includes("/outlet") && 
                <Container className="navbar-hyundai-mobile">
                    <Row className="justify-content-end">
                        <Col className="d-md-none">
                            <Row>
                                <Col className="my-auto"><Link to="/"><img alt="logo-hyundai" src={logoHyuidaiMBlanco} /> </Link></Col>
                                <Col>
                                    <Row className="justify-content-end">
                                        <button onClick={handleShow} className="btn bg-transparent">
                                            <img alt="menu-responsive-hyundai" src={iconMenuMBlanco} />
                                        </button>
                                    </Row>
                                </Col>
                                <Drawer
                                    className="drawer-mobile-menu"
                                    placement="left"
                                    closable={true}
                                    onClose={handleHide}
                                    visible={show}
                                    key="left"
                                    zIndex={1030}
                                >
                                    <Container fluid >
                                        <Row>
                                            <Col xs={12} sm={12} md={12} lg={9} xl={9} className={`d-block d-md-none `} >
                                                <Row className=" justify-content-md-center justify-content-lg-end mt-3">
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/vehiculos">
                                                            <p className={` ${currentRoute.includes("vehiculos") && !currentRoute.includes("outlet")  ? "active-link" : ""} link-text py-1 my-2`}>Vehículos</p>
                                                        </Link>
                                                    </Col>
                                                    {/* OUTLET OFF */}
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/outlet/vehiculos">
                                                            <p className={`${currentRoute.includes("outlet") && "active-link"} link-text py-1 my-2`}>Outlet</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/concesionarios">
                                                            <p className={`${currentRoute.includes("concesionario") && "active-link"} link-text py-1 my-2`}>Concesionarios</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/servicio-tecnico">
                                                            <p className={` ${currentRoute.includes("serviciot") && "active-link"} link-text py-1 my-2`}>Servicio técnico</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/repuestos">
                                                            <p className={` ${currentRoute.includes("repuestos") && !currentRoute.includes("outlet")  ? "active-link" : ""} link-text py-1 my-2`}>Repuestos</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/flotas">
                                                            <p className={`${currentRoute.includes("flotas") && "active-link"} link-text py-1 my-2`}>Flotas</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb">
                                                        <Link className="text-left" to="/mercado-publico">
                                                            <p className={`${currentRoute.includes("mercado") && "active-link"} link-text py-1 my-2`}>Mercado público</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto" className="my-auto mx-lg-1 mx-xl-auto border-breadcrumb last-col-menu">
                                                        <Link className="text-left" to="/atencion-al-cliente">
                                                            <p className={`${currentRoute.includes("atencion") && "active-link"} link-text py-1 my-2`}>Servicio al cliente</p>
                                                        </Link>
                                                    </Col>
                                                    <Col xs={12} sm={12} md="auto">
                                                        <Input 
                                                            bordered={false} 
                                                            prefix={<img src={buscarBlanco}/>} 
                                                            className="input-search" 
                                                            placeholder="Realizar búsqueda" 
                                                            onChange={handleChange} 
                                                            onKeyDown={handleKeyDown} 
                                                            type="search"
                                                        />
                                                        {/* <SearchMenu/> */}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Drawer>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            }

            <ScrollButton scrollXL={scrollXL} />
            <WhatsAppButton btnXL={scrollXL} visible={whatsappVisible} />
        </nav>
    );
}

const MenuLogeado = () => {
    const dispatch = useDispatch();
    const cerrarSesion = () => dispatch(logOut());

    return (
        <Menu>
            <Menu.Item className="py-0 my-0 mt-md-3 pr-md-5">
                <Link to="/perfil" className="color-white-hy parrafo-hyundai f-responsive">
                    Mi Perfil
                </Link>
            </Menu.Item>
            <Menu.Item className="py-0 my-0 pb-1 pr-md-5">
                <Link to="/perfil/compras" className="color-white-hy parrafo-hyundai f-responsive">
                    Mis compras
                </Link>
            </Menu.Item>
            <Menu.Item className="color-white-hy border-top-white-hy parrafo-hyundai f-responsive py-0 my-md-2 mt-2 pr-5" onClick={cerrarSesion}>
                Cerrar sesión
            </Menu.Item>
        </Menu>
    )

}

const MenuLogin = () => {
    return (
        <Menu>
            <Menu.Item className="py-0 my-0 pr-md-5">
                <Link to="/login" className="color-white-hy parrafo-hyundai f-responsive">
                    Iniciar Sesión
                </Link>
            </Menu.Item>
            <Menu.Item className="py-0 my-0 pr-md-5">
                <Link to="/registrarse" className="color-white-hy parrafo-hyundai f-responsive">
                    Registrarme
                </Link>
            </Menu.Item>
        </Menu>
    )
}

export default Navbar;